import { combineReducers } from "redux"
import places from "./places"
import trips from "./trips"
import transactions from "./transactions"
import vehicles from "./vehicles"
import user from "./user"
import favoriteTrips from "./favoriteTrips"
import dataExports from "./dataExports"
import dataExportsTeams from "./dataExportsTeams"
import plans from "./plans"
import invoices from "./invoices"
import {
  isMatchingFilters,
  isNotMatchingFilters,
  isSameDate
} from "./selectors"

export default combineReducers({
  user,
  trips,
  transactions,
  places,
  favorite_trips: favoriteTrips,
  vehicles,
  dataExports,
  dataExportsTeams,
  plans,
  invoices
})

// SELECTORS
export { isMatchingFilters, isNotMatchingFilters, isSameDate }



// WEBPACK FOOTER //
// ./src/models/index.js